import React from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function HLSPlayer({ videoFilename, watermarkText, ...props }) {
  if (!videoFilename) return null;

  const src = videoFilename.startsWith('videos/')
    ? `${API_URL}/api/videos/r2/${videoFilename}`
    : `${API_URL}/api/videos/${videoFilename}`;

  return (
    <div className="relative w-full h-full protected-video" style={{ WebkitUserSelect: 'none', userSelect: 'none' }}>
      <video
        controls
        playsInline
        preload="auto"
        className="w-full h-full"
        data-testid="drill-video"
        src={src}
        controlsList="nodownload"
        onContextMenu={(e) => e.preventDefault()}
        {...props}
      />
      {watermarkText && (
        <div
          className="absolute inset-0 pointer-events-none flex items-end justify-end p-3"
          style={{ zIndex: 10 }}
        >
          <span className="text-white/30 text-[10px] font-bold tracking-wider select-none">
            {watermarkText}
          </span>
        </div>
      )}
    </div>
  );
}
